export const getFullString = (...args: string[]): string => {
  return args
    .map((arg) => arg ?? '')
    .join(' ')
    .trim();
};
